module.exports = __webpack_public_path__ + "fonts/NanumSquareB.284774d9.ttf";